import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonSummarizePreview',
  props: {
    visible: { type: Boolean },
    loading: { type: Boolean },
    rateLimited: { type: Boolean },
    errorMessage: null,
    first: null,
    displayText: null,
    originalLength: null,
    isYagiPrime: { type: Boolean }
  },
  emits: ["close", "open-prime", "apply", "open-modal"],
  setup(__props: any) {





return { __sfc: true, }
}

})